import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  IconButton,
  Tooltip,
  useMediaQuery,
  Breadcrumbs,
  LinearProgress,
  CircularProgress,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Cell,
  Legend,
} from "recharts";
import GaugeChart from "react-gauge-chart";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Certificate from "./Pdf/Certificate";
import { useLocation, useNavigate } from "react-router-dom";
import { useProSidebar } from "react-pro-sidebar";
import Swal from "sweetalert2";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { ResponsiveContainer } from "recharts";
import Chart from "react-apexcharts"; // ✅ ApexCharts import
import {
  AppraisalScoredashBoard,
  ScoredashBoard,
} from "../../store/reducers/LoginReducer";
import { useDispatch, useSelector } from "react-redux";
import { BlobProvider } from "@react-pdf/renderer";

const AppraisalDashboard = () => {
  // Calculate percentage for gauge
  // const total = chartData.length;
  // const correct = chartData.filter((x) => x.score === 1).length;
  //const percent = correct / total;
  const dispatch = useDispatch();

  const location = useLocation();
  const state = location.state || {};
  const empID = sessionStorage.getItem("EmpId");

  //STATE PASSING
  const AssessmentName = state.AssessmentName;
  const AppraisalID = state.AppraisalID;
  const Lastattdate = state.Lastattdate;
  const Lastattscore = state.Lastattscore;
  const Firstattdate = state.Firstattdate;
  const NoofAttemp = state.NoofAttemp;
  //const Lastattscore = Number(state.Lastattscore) / 100;

  const EmployeeName = state.EmployeeName;

  const { toggleSidebar, broken, rtl } = useProSidebar();
  const navigate = useNavigate();

  const isNonMobile = useMediaQuery("(min-width:600px)");
  useEffect(() => {
    // dispatch(dashBoardTask({ data: { EmployeeID: empID } }));
    dispatch(
      AppraisalScoredashBoard({
        data: { EmployeeID: empID, AppraisalID: AppraisalID },
      })
    );
  }, []);

  const ScoredashBoardGetData = useSelector(
    (state) => state.loginApi.AppraisaldashBoardGetData
  );
  // SCORE

  const rawScore1 = ScoredashBoardGetData?.Data?.ManagersScore
    ? parseFloat(ScoredashBoardGetData.Data.ManagersScore)
    : null;

  const rawScore2 = ScoredashBoardGetData?.Data?.SubordinatesScore
    ? parseFloat(ScoredashBoardGetData.Data.SubordinatesScore)
    : null;

  const rawScore3 = ScoredashBoardGetData?.Data?.PeersScore
    ? parseFloat(ScoredashBoardGetData.Data.PeersScore)
    : null;

  const Lastattscore1 = rawScore1 !== null ? rawScore1 / 100 : 0;
  const Lastattscore2 = rawScore2 !== null ? rawScore2 / 100 : 0;
  const Lastattscore3 = rawScore3 !== null ? rawScore3 / 100 : 0;
  const Lastattscore4 = Lastattscore !== null ? Lastattscore / 100 : 0;

  //const attemptLength = series[0]?.data?.length || 0;

  // const colors =
  //   attemptLength > 0
  //     ? Array.from({ length: attemptLength }, (_, i) =>
  //         i === attemptLength - 1 ? "#43A047" : "#E53935"
  //       )
  //     : [];

  const ScoredashBoardGetStaus = useSelector(
    (state) => state.loginApi.AppraisaldashBoardGetStaus
  );
  console.log(
    "🚀 ~ AssessmentDashboard ~ ScoredashBoardGetStaus:",
    ScoredashBoardGetStaus
  );

  const ScoredashBoardGetLoading = useSelector(
    (state) => state.loginApi.AppraisaldashBoardGetLoading
  );
  const ScoredashBoardGetError = useSelector(
    (state) => state.loginApi.AppraisaldashBoardGetError
  );
  console.log(
    "🚀 ~ AssessmentDashboard ~ ScoredashBoardGetError:",
    ScoredashBoardGetError
  );
  const fnLogOut = (props) => {
    Swal.fire({
      title: `Do you want ${props}?`,
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR026/Department");
        }
      } else {
        return;
      }
    });
  };
  //LOADING

  return (
    <Box
      sx={{
        p: 2,
        height: "100vh",
      }}
    >
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              <Breadcrumbs
                maxItems={3}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => navigate(-1)}
                >
                  List Of Assessment ({AssessmentName})
                </Typography>

                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  Assessment Dashboard
                </Typography>
              </Breadcrumbs>
            </Box>
          </Box>

          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {ScoredashBoardGetLoading ? (
        <LinearProgress />
      ) : (
        <>
          <Paper elevation={3} sx={{ margin: "10px", padding: "20px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="h4" gutterBottom>
                  Appraisal Dashboard
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            {/* Charts Row */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {/* Gauge Chart */}
              <Box
                sx={{
                  flex: { xs: "100%", md: "50%" },
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <GaugeChart
                    id="gauge-chart1"
                    nrOfLevels={10}
                    percent={Lastattscore4}
                    textColor="#000"
                    colors={["#e53935", "#43a047"]}
                    needleColor="#000"
                    style={{
                      width: "100%", // responsive width
                      maxWidth: "350px", // cap the maximum size
                      height: "auto",
                    }}
                  />
                  <div
                    style={{
                      marginTop: "8px",
                      fontWeight: "600",
                      color: "#333",
                    }}
                  >
                    Self Score
                  </div>
                </div>
              </Box>
              <Box
                sx={{
                  flex: { xs: "100%", md: "50%" },
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <GaugeChart
                    id="gauge-chart1"
                    nrOfLevels={10}
                    percent={Lastattscore3}
                    textColor="#000"
                    colors={["#e53935", "#43a047"]}
                    needleColor="#000"
                    style={{
                      width: "100%", // responsive width
                      maxWidth: "350px", // cap the maximum size
                      height: "auto",
                    }}
                  />

                  <div
                    style={{
                      marginTop: "8px",
                      fontWeight: "600",
                      color: "#333",
                    }}
                  >
                    Peer's Score
                  </div>
                </div>
              </Box>

              <Box
                sx={{
                  flex: { xs: "100%", md: "50%" },
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
    marginTop: { xs: 0, md: "50px" }, // Apply margin-top only on md+
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <GaugeChart
                    id="gauge-chart1"
                    nrOfLevels={10}
                    percent={Lastattscore1}
                    textColor="#000"
                    colors={["#e53935", "#43a047"]}
                    needleColor="#000"
                    style={{
                      width: "100%", // responsive width
                      maxWidth: "350px", // cap the maximum size
                      height: "auto",
                    }}
                  />
                  <div
                    style={{
                      marginTop: "8px",
                      fontWeight: "600",
                      color: "#333",
                    }}
                  >
                    Manager’s Score
                  </div>
                </div>
              </Box>
              <Box
                sx={{
                  flex: { xs: "100%", md: "50%" },
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: { xs: 0, md: "50px" }, // Apply margin-top only on md+
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <GaugeChart
                    id="gauge-chart1"
                    nrOfLevels={10}
                    percent={Lastattscore2}
                    textColor="#000"
                    colors={["#e53935", "#43a047"]}
                    needleColor="#000"
                    style={{
                      width: "100%", // responsive width
                      maxWidth: "350px", // cap the maximum size
                      height: "auto",
                    }}
                  />

                  <div
                    style={{
                      marginTop: "8px",
                      fontWeight: "600",
                      color: "#333",
                    }}
                  >
                    Subordinate's Score
                  </div>
                </div>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />
          </Paper>
        </>
      )}
    </Box>
  );
};

export default AppraisalDashboard;
